import axios from 'axios';

// export const login = (userName, pwd) => {
//     pwd = md5(pwd);
//     var url = `java://login`;
//     return axios.post(url, { userName, pwd, });
// };

export const login = (body) => {
    var url = `/8080/auth/login`;
    return axios.post(url, body);
};

export const getUserInfo = (body) => {
    var url = `/8080/kinovo-system/org/getUserInfo`;
    return axios.post(url, body);
};

export const getUserMenu = (body) => {
    var url = `/8080/kinovo-system/role/getUserMenu`;
    return axios.post(url, body);
};

export const getUserLoginInfo = (body) => {
    var url = `/8080/kinovo-system/user/getUserLoginInfo`;
    return axios.post(url, body);
};
